import { useEffect } from "react"

const SCHEMA = {
  "@context": "https://schema.org",
  "@graph": [
    {
      "@type": "Person",
      "@id": "https://r4v3n.art/#artist",
      "name": "r4v3n",
      "url": "https://r4v3n.art",
      "jobTitle": "Artist",
      "description": "Generative artist working in code, print, and photography. On-chain works include Moments, Pieces of Me, Color Streams, and Marfa: Middle of Somewhere.",
      "sameAs": [
        "https://x.com/r4v3n_art",
        "https://www.artblocks.io/marketplace/artists/r4v3n"
      ]
    },
    {
      "@type": "WebSite",
      "@id": "https://r4v3n.art/#website",
      "name": "r4v3n",
      "url": "https://r4v3n.art",
      "description": "r4v3n — generative artist. On-chain generative art and 1/1 works fusing algorithms with human emotion.",
      "author": { "@id": "https://r4v3n.art/#artist" }
    }
  ]
}

const JsonLd = () => {
  useEffect(() => {
    const script = document.createElement("script")
    script.type = "application/ld+json"
    script.textContent = JSON.stringify(SCHEMA)
    document.head.appendChild(script)
    return () => { document.head.removeChild(script) }
  }, [])
  return null
}

export default JsonLd
